// @flow
import HubEntreprise from 'components/hubentreprise/HubEntreprise';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/hubentreprise/HubEntreprise';

export default connect(
  (state: StateType): StateProps => ({
    bloc_entreprise: state.settingsState.bloc_entreprise,
  })
)(HubEntreprise);
